import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from "../../services/authentication/authentication.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {

  //#region Fields
  public languageId: number = 0
  public countryCode: string = "";
  public termsAndConditionsText: SafeHtml;
  public isLoggedIn: boolean = false;
  public unsubscribe: Subject<void> = new Subject<void>();
  //#endregion

  //#region Constructor
  constructor(private authService: AuthenticationService, private sanitizer: DomSanitizer) {
  }

  public ngOnInit(): void {
    this.authService.loginUser.pipe(takeUntil(this.unsubscribe)).subscribe(response => {
      this.isLoggedIn = !!response;
    });
    this.getTermsAndConditions();
  }
  //#endregion

  //#region Public Methods
  public getTermsAndConditions(): void {
    let id = localStorage.getItem('languageId');
    if (id != null) {
      this.languageId = parseInt(id);
    }
    let language = localStorage.getItem('language');
    if (language != null) {
      this.countryCode = language;
    }
    this.authService.getTermsAndConditions(this.languageId, this.countryCode).subscribe((response) => {
      if (response) {
        this.termsAndConditionsText = this.sanitizer.bypassSecurityTrustHtml(response.textContent);
      }
    });
  }
  //#endregion
}
